import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const OpsGenieShape = {
  api_endpoint: Yup.string().label("API Endpoint").url().min(10).max(255).required(),
  api_key: Yup.string().label("API Key").min(36).max(36).required(),
  teams: Yup.string().label("Teams").max(1000).optional(),
  tags: Yup.string().label("Tags").max(1000).optional(),
  autoresolve: Yup.boolean().label("Auto-resolve Incident").optional(),
};

export interface OpsGenieInput {
  api_endpoint: string;
  api_key: string;
  teams?: string;
  tags?: string;
  autoresolve?: boolean;
}

export const OpsGenieDefaults = {
  api_endpoint: "https://api.opsgenie.com/v1/json/uptime",
};

yupResolver<OpsGenieInput>(Yup.object().shape(OpsGenieShape));
